export const INSIGHT_REMOVE_CONFIRM_ID = 'insight-remove-confirm';
export const INSIGHT_WRITING_ASSISTANT_CONFIRM_ID = 'writing-assistant-confirm';
export const EMPTY_VALUE = '';
export const INSIGHT_TEAM_SELECTION_ID = 'team-selection-confirm';
export const INSIGHT_PROJECT_SELECTION_ID = 'project-selection-confirm';
export const INSIGHT_SUCCESS_CONFIRMATION_ID = 'insight-success-confirmation';
export const FILE_OBJECTS = [
  { extension: '.apng', fileType: 'image/apng' },
  { extension: '.bmp', fileType: 'image/bmp' },
  { extension: '.gif', fileType: 'image/gif' },
  { extension: '.jif', fileType: 'image/jif' },
  { extension: '.jfif', fileType: 'image/jfif' },
  { extension: '.jpe', fileType: 'image/jpe' },
  { extension: '.jpg', fileType: 'image/jpeg' },
  { extension: '.jpeg', fileType: 'image/jpeg' },
  { extension: '.png', fileType: 'image/png' },
  { extension: '.pjpeg', fileType: 'image/pjpeg' },
  { extension: '.pjp', fileType: 'image/pjp' },
  { extension: '.webp', fileType: 'image/webp' },
];
